import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebaseSetup";
import { CHECK_AUTH_STATUS, SIGN_OUT } from "../actions/action-types";
import { signInSuccess, signOutSuccess } from "../actions/user-actions";
import { setNextLocation } from "../actions/ui-actions";
import { call, put, fork, takeLatest } from "redux-saga/effects";
import { get } from "./firebase-saga";
import { setUser } from "../actions/user-actions";
import API from "../api";

export function getCurrentUser() {
  return new Promise((resolve, reject) => {
    onAuthStateChanged(
      auth,
      (user) => resolve(user),
      (error) => reject(error)
    );
  });
}

export function* checkAuthStatus(action) {
  try {
    // In mock mode, currentUser is already set in the initial state
    const isMockMode = process.env.REACT_APP_USE_MOCK_DATA === "true";
    if (isMockMode) {
      // Just call the next callback, auth is handled by mock data
      if (action.payload && action.payload.next) {
        yield call(action.payload.next, null);
      }
      return;
    }

    const { nextState } = action.payload || {};
    const nextLocation = nextState && nextState.location && nextState.location.pathname;
    const user = yield call(getCurrentUser, null);

    if (user) {
      yield put(signInSuccess(user));
      const userModel = yield call(get, "users", user.uid);
      yield put(setUser(userModel));
    } else {
      yield put(signOutSuccess());
    }

    if (user || !action.payload.requireAuth) {
      yield call(action.payload.next, null);
    } else {
      yield put(setNextLocation(nextLocation));
      window.location.replace("/login");
    }
  } catch (errors) {
    console.log(errors);
  }
}

export function* watchCheckAuthStatus() {
  yield fork(takeLatest, CHECK_AUTH_STATUS, checkAuthStatus);
}

export function* signOut() {
  try {
    yield call(API.signOut, null);
    yield put(signOutSuccess());
    window.location.href = "/";
  } catch (errors) {
    console.log(errors);
  }
}

export function* watchSignOut() {
  yield fork(takeLatest, SIGN_OUT, signOut);
}
